<div
	class="chat-message"
	[class.user-message]="message().isUser"
	[class.agent-message]="message().isAgent"
	[class.error-message]="message().status === 'error'"
	[class.sending-message]="message().status === 'sending'"
>
	<div class="message-avatar">
		@if (message().isAgent) {
			@if (message().status === 'sending') {
				<div class="loading-spinner">
					<md-icon [icon]="'untitled-ui/general/loading-01'" class="spinning"></md-icon>
				</div>
			} @else {
				<md-icon [icon]="'untitled-ui/shapes/star-04'"></md-icon>
			}
		} @else {
			<div class="user-avatar">{{ userInitials() }}</div>
		}
	</div>
	<div class="message-content">
		<div class="message-header">
			<span class="message-sender">
				@if (message().isUser) {
					You
				} @else if (message().status === 'sending') {
					AI Assistant is thinking...
				} @else {
					AI Assistant
				}
			</span>
			<span class="message-timestamp">{{ getFormattedTime(message().timestamp) }}</span>
		</div>

		@if (message().status === 'error') {
			<div class="message-error">
				<md-icon [icon]="'untitled-ui/general/alert-circle'"></md-icon>
				<div class="error-content">
					<span>{{ message().error || 'Failed to send message' }}</span>
					<button class="retry-button" (click)="onRetry()" type="button">
						<md-icon [icon]="'untitled-ui/arrows/refresh-cw-01'"></md-icon>
						Try Again
					</button>
				</div>
			</div>
		} @else {
			<div class="message-bubble" #messageBubble>
				@if (isMarkdown(message().content)) {
					<markdown [data]="message().content"></markdown>
				} @else {
					<span [innerHTML]="linkifyText(message().content)"></span>
				}
			</div>

			@if (message().citations && (message().citations?.length ?? 0) > 0) {
				<div class="message-citations">
					<div class="citations-header">
						<md-icon [icon]="'untitled-ui/general/book-open-01'"></md-icon>
						<span>Sources</span>
					</div>
					<div class="citations-list">
						@for (citation of message().citations; track citation.title) {
							<a [href]="citation.url" target="_blank" class="citation-item">
								<md-icon [icon]="'untitled-ui/general/link-external-01'"></md-icon>
								<span class="citation-title">{{ citation.title }}</span>
								@if (citation.snippet) {
									<span class="citation-snippet">{{ citation.snippet }}</span>
								}
							</a>
						}
					</div>
				</div>
			}
		}
	</div>
</div>
